/**
 * The precious data mark. Two cuts, per the design system: below 40px the
 * arms are shorter and the head larger so the break stays visible at small
 * sizes; at 40px and up use the full cut. Inherits color via currentColor,
 * so wrap in a text color class (e.g. text-brand) rather than passing fill.
 */
export const PdMark = ({ size = 26, className = '' }) => {
  const small = size < 40;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth={small ? 4.6 : 3.2}
      strokeLinecap="round"
      role="img"
      aria-label="precious data"
      className={className}
    >
      {small ? (
        <>
          <path d="M7 21A17 17 0 0 0 14.01 34.75" />
          <path d="M41 21A17 17 0 0 1 33.99 34.75" />
          <path d="M12 13H36" />
          <path d="M17 24H31" />
          <circle cx="24" cy="37" r="4.9" fill="currentColor" stroke="none" />
        </>
      ) : (
        <>
          <path d="M6 21A18 18 0 0 0 15 36.59" />
          <path d="M42 21A18 18 0 0 1 33 36.59" />
          <path d="M11 13H37" />
          <path d="M16 24H32" />
          <circle cx="24" cy="37.6" r="4.6" fill="currentColor" stroke="none" />
        </>
      )}
    </svg>
  );
};

export default PdMark;
